






























































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { Job } from "../common/interfaces";
import DetailHeader from "../components/DetailHeader.vue";
import LongQuestion from "../components/LongQuestion.vue";
import moment from "moment";
import store from "@/store/store";
import { ActionNames, ToggleQuestion } from "@/store/actions";
import { loadExamDetail } from "@/common/jobLoader";
import CompleteJob from "@/components/completeJob/CompleteJob.vue";
import DateTimePicker from "@/components/DateTimePicker.vue";

export interface BigQuestion {
  question: string;
  value?: string;
  function?: (e: FocusEvent) => void;
  component?: {
    name: string;
    props: { [key: string]: any };
  };
}

@Component({
  components: {
    DetailHeader,
    LongQuestion,
    CompleteJob,
    DateTimePicker,
  },
})
export default class ExamDetail extends Vue {
  protected loadingJob: boolean = true;
  protected storedDefectDetails: string = "";
  protected storedDefectRemedy: string = "";
  protected completeJob: boolean = false;
  // Lifecycles

  public created() {
    this.$watch(() => this.$route.params.id, this.loadJob);
    this.loadJob(this.$route.params.id);
  }

  public async loadJob(jobId: string) {
    this.loadingJob = true;

    try {
      await loadExamDetail(jobId);
    } catch (err) {
      this.$router.push("/");
      this.$notify.error({
        title: "Error",
        message: err.message,
        offset: 48,
      });
    } finally {
      this.loadingJob = false;
    }
  }

  // Functions

  public displayDate(date: moment.Moment) {
    return date.isValid() ? date.format("DD-MMM-YYYY") : "No Date";
  }

  public nearbyJobsClicked() {
    this.$router.push(`/ByPostcode/${this.jobDetail!.AddressPostcode}`);
  }
  public completeJobClosed() {
    this.completeJob = false;
  }
  public requiredPartsClicked() {
    this.$router.push(`${this.$route.path}/Parts`);
  }
  public backClicked() {
    this.$router.go(-1);
  }

  public doneClicked() {
    this.completeJob = true;
  }
  public async setRoteIncluded(newValue: boolean | null) {
    try {
      await store.dispatch(ActionNames.SetRoteIncluded, newValue);
    } catch (err) {
      this.$notify.error({
        title: "Error",
        message: err.message,
        offset: 48,
      });
    }
  }
  public async nextRoteDueSelected(newDate: string) {
    const currentNextRoteDue = moment(this.nextRoteDue);
    const nextRoteDue: moment.Moment = moment(newDate);
    nextRoteDue.set({
      hour: currentNextRoteDue ? currentNextRoteDue.get("hour") : 0,
      minute: currentNextRoteDue ? currentNextRoteDue.get("minute") : 0,
    });
    this.updateNextRoteDue(nextRoteDue);
  }
  public async updateNextRoteDue(newValue: moment.Moment) {
    try {
      await store.dispatch(ActionNames.SetNextRoteDue, newValue);
    } catch (err) {
      this.$notify.error({
        title: "Error",
        message: err.message,
        offset: 48,
      });
    }
  }
  // used for the blur event
  public async proofLoadChanged(event: FocusEvent) {
    if (event.target) {
      try {
        await store.dispatch(
          ActionNames.SetProofLoad,
          (event.target as HTMLInputElement).value
        );
      } catch (err) {
        this.$notify.error({
          title: "Error",
          message: err.message,
          offset: 48,
        });
      }
    }
  }

  // used for the blur event
  public async radiusChanged(event: FocusEvent) {
    if (event.target) {
      try {
        await store.dispatch(
          ActionNames.SetRadius,
          (event.target as HTMLInputElement).value
        );
      } catch (err) {
        this.$notify.error({
          title: "Error",
          message: err.message,
          offset: 48,
        });
      }
    }
  }

  public arrivedOnSiteDateChanged(newDate: string) {
    const currentArrivedOnSite = this.examDetail!.ArrivedOnSite;
    const arrivedOnSite: moment.Moment = moment(newDate);
    arrivedOnSite.set({
      hour: currentArrivedOnSite ? currentArrivedOnSite.get("hour") : 0,
      minute: currentArrivedOnSite ? currentArrivedOnSite.get("minute") : 0,
    });
    this.updateArrivedOnSite(arrivedOnSite);
  }

  public arrivedOnSiteTimeChanged(newTime: string) {
    const arrivedOnSite: moment.Moment =
      moment(this.examDetail!.ArrivedOnSite) || moment();
    const timeParts = newTime.split(":");
    arrivedOnSite.set({
      hour: parseInt(timeParts[0], 10),
      minute: parseInt(timeParts[1], 10),
    });
    this.updateArrivedOnSite(arrivedOnSite);
  }

  public ArrivedNowClicked() {
    const arrivedOnSite: moment.Moment = moment();
    let minutes = arrivedOnSite.get("minute");
    minutes = minutes - (minutes % 15);
    arrivedOnSite.set({
      minute: minutes,
      seconds: 0,
    });
    this.updateArrivedOnSite(arrivedOnSite);
  }

  public async updateArrivedOnSite(newValue: moment.Moment) {
    try {
      await store.dispatch(ActionNames.SetArrivedOnSite, newValue);
    } catch (err) {
      this.$notify.error({
        title: "Error",
        message: err.message,
        offset: 48,
      });
    }
  }

  public async liftSafeChanged(newValue: boolean) {
    try {
      if (newValue) {
        this.storedDefectDetails = this.examDetail!.DefectDetails || "";
        this.storedDefectRemedy = this.examDetail!.DefectRemedy || "";
        this.updateDefectDetails(store.state.EMPTY_STRING);
        this.updateDefectRemedy(store.state.EMPTY_STRING);
      } else {
        if (this.examDetail!.DefectDetails === store.state.EMPTY_STRING) {
          this.updateDefectDetails(this.storedDefectDetails);
        }
        if (this.examDetail!.DefectRemedy === store.state.EMPTY_STRING) {
          this.updateDefectRemedy(this.storedDefectRemedy);
        }
      }

      await store.dispatch(ActionNames.SetLiftSafe, newValue);
    } catch (err) {
      this.$notify.error({
        title: "Error",
        message: err.message,
        offset: 48,
      });
    }
  }

  public defectDetailsChanged(event: FocusEvent) {
    if (event.target) {
      this.updateDefectDetails((event.target as HTMLTextAreaElement).value);
    }
  }

  public async updateDefectDetails(newValue: string) {
    try {
      await store.dispatch(ActionNames.SetDefectDetails, newValue);
    } catch (err) {
      this.$notify.error({
        title: "Error",
        message: err.message,
        offset: 48,
      });
    }
  }

  public remedyDefectsChanged(event: FocusEvent) {
    if (event.target) {
      this.updateDefectRemedy((event.target as HTMLTextAreaElement).value);
    }
  }

  public async updateDefectRemedy(newValue: string) {
    try {
      await store.dispatch(ActionNames.SetDefectRemedy, newValue);
    } catch (err) {
      this.$notify.error({
        title: "Error",
        message: err.message,
        offset: 48,
      });
    }
  }

  public async inaccessiblePartsChanged(event: FocusEvent) {
    if (event.target) {
      try {
        await store.dispatch(
          ActionNames.SetInaccessibleParts,
          (event.target as HTMLTextAreaElement).value
        );
      } catch (err) {
        this.$notify.error({
          title: "Error",
          message: err.message,
          offset: 48,
        });
      }
    }
  }

  public async workDoneChanged(event: FocusEvent) {
    if (event.target) {
      try {
        await store.dispatch(
          ActionNames.SetDefectWork,
          (event.target as HTMLTextAreaElement).value
        );
      } catch (err) {
        this.$notify.error({
          title: "Error",
          message: err.message,
          offset: 48,
        });
      }
    }
  }

  public async nextVisitNotesChanged(event: FocusEvent) {
    if (event.target) {
      try {
        await store.dispatch(
          ActionNames.SetVisitNotes,
          (event.target as HTMLTextAreaElement).value
        );
      } catch (err) {
        this.$notify.error({
          title: "Error",
          message: err.message,
          offset: 48,
        });
      }
    }
  }

  public async safeWorkingLoadChanged(event: FocusEvent) {
    if (event.target) {
      try {
        await store.dispatch(
          ActionNames.SetSafeWorkingLoad,
          (event.target as HTMLInputElement).value
        );
      } catch (err) {
        this.$notify.error({
          title: "Error",
          message: err.message,
          offset: 48,
        });
      }
    }
  }
  async updateToggleQuestion(value: boolean | null, question: ToggleQuestion) {
    try {
      await store.dispatch(ActionNames.SetRoteToggleQuestion, {
        question: question,
        newValue: value,
      });
    } catch (err) {
      this.$notify.error({
        title: "Error",
        message: err.message,
        offset: 48,
      });
    }
  }
  async additionalParticularsChanged(event: FocusEvent) {
    if (event.target) {
      try {
        await store.dispatch(
          ActionNames.SetAdditionalParticulars,
          (event.target as HTMLTextAreaElement).value
        );
      } catch (err) {
        this.$notify.error({
          title: "Error",
          message: err.message,
          offset: 48,
        });
      }
    }
  }

  isToggleQuestionRequired(toggleQuestion: ToggleQuestion) {
    return (
      (toggleQuestion.customRequiredCheck &&
        !toggleQuestion.customRequiredCheck() &&
        toggleQuestion.value == null) ||
      (!toggleQuestion.customRequiredCheck &&
        toggleQuestion.value == null &&
        !toggleQuestion.textOnly)
    );
  }

  // Getters
  get roteIncluded() {
    return this.jobDetail!.ROTEIncluded;
  }
  get nextRoteDue() {
    // If not set show as today + year
    return (
      this.jobDetail!.NextRoteDue || moment().startOf("day").add(1, "year")
    );
  }
  get jobId() {
    return store.state.Job.JobId;
  }

  get jobDetail() {
    return store.state.Job.JobDetail;
  }

  get examDetail() {
    return store.state.Job.ExamDetail;
  }

  get arrivedOnSiteTime() {
    let arrivedTime: string = "00:00";
    if (this.examDetail!.ArrivedOnSite) {
      arrivedTime = this.examDetail!.ArrivedOnSite!.isValid()
        ? this.examDetail!.ArrivedOnSite!.format("HH:mm")
        : "00:00";
    }
    return arrivedTime;
  }

  get bigQuestions() {
    if (this.examDetail) {
      const bigQuestions: BigQuestion[] = [
        {
          question:
            `Details of any defect that is or could become a danger to persons, ` +
            `including the date when it would become a danger to persons:`,
          value: this.examDetail!.DefectDetails || "",
          function: this.defectDetailsChanged,
        },
        {
          question: "Details of work required to remedy any such defect:",
          value: this.examDetail!.DefectRemedy || "",
          function: this.remedyDefectsChanged,
        },
        {
          question: "Details of parts, if any, which were inaccessible:",
          value: this.examDetail!.InaccessibleParts || "",
          function: this.inaccessiblePartsChanged,
        },
        {
          question: "Details of work carried out:",
          value: this.examDetail!.DefectWork || "",
          function: this.workDoneChanged,
        },
        {
          question: "Next Visit/Job Failed notes:",
          value: this.examDetail!.VisitNotes || "",
          function: this.nextVisitNotesChanged,
        },
      ];
      return bigQuestions;
    } else {
      return [];
    }
  }

  get detailDescription() {
    if (this.jobDetail) {
      return `(${store.state.Job.JobId}) ${
        this.jobDetail!.JobDescription
      } examination details for ${this.jobDetail!.DivisionName}`;
    }
  }
  get validateRoteQuestions() {
    if (!this.jobDetail) {
      return true;
    }
    for (const toggleQuestion of this.roteToggleQuestions) {
      if (this.isToggleQuestionRequired(toggleQuestion)) {
        return false;
      }
    }
    for (const bigQuestion of this.roteBigQuestions) {
      if (bigQuestion.value == null || !bigQuestion.value.trim().length) {
        return false;
      }
    }
    return true;
  }
  get roteBigQuestions() {
    if (this.examDetail) {
      return [
        {
          question:
            "Any additional particulars of any test carried out as part of the Through Examination (if none, state NONE):",
          value: this.examDetail.AddParticulars || "",
          function: this.additionalParticularsChanged,
        },
      ] as BigQuestion[];
    } else {
      return [];
    }
  }

  get roteToggleQuestions(): ToggleQuestion[] {
    if (this.examDetail) {
      return [
        {
          question:
            "1. Is this a Factory Thorough Examination at point of manufacture?",
          value: this.examDetail.FactoryThorough,
          function: this.updateToggleQuestion,
          entityFieldName: "ExamFactoryThorough",
          storeFieldName: "FactoryThorough",
        },
        {
          question: "2. a) Is this a commissioning Examination?",
          value: this.examDetail.FirstAfterInstall,
          function: this.updateToggleQuestion,
          entityFieldName: "ExamFirstAfterInstall",
          storeFieldName: "FirstAfterInstall",
        },
        {
          question: "2. b) If YES, is this installed correctly?",
          value: this.examDetail.EqInstallCorrect,
          function: this.updateToggleQuestion,
          entityFieldName: "ExamEqInstallCorrect",
          storeFieldName: "EqInstallCorrect",
          customRequiredCheck: () => {
            const firstInstallQuestion: ToggleQuestion | undefined =
              this.roteToggleQuestions.find(
                (x: ToggleQuestion) =>
                  x.entityFieldName === "ExamFirstAfterInstall"
              );
            // Only require the field if first install is YES
            return firstInstallQuestion && !firstInstallQuestion.value;
          },
        },
        {
          question: "3. Was the Examination:",
          textOnly: true,
        },
        {
          question: "3. a) 6 Monthly Examination (e.g. Lifiting Accessories)?",
          value: this.examDetail.Within6Months,
          function: this.updateToggleQuestion,
          entityFieldName: "ExamWithin6Months",
          storeFieldName: "Within6Months",
        },
        {
          question:
            "3. b) 12 Monthly Examination (e.g. Standard No-manriding lifting Equipment)?",
          value: this.examDetail.Within12Months,
          function: this.updateToggleQuestion,
          entityFieldName: "ExamWithin12Months",
          storeFieldName: "Within12Months",
        },
        {
          question:
            "3. d) Exceptional Circumstance Outside the routine examinations (e.g. re-rope)?",
          value: this.examDetail.AfterExcept,
          function: this.updateToggleQuestion,
          entityFieldName: "ExamAfterExcept",
          storeFieldName: "AfterExcept",
        },
      ] as ToggleQuestion[];
    } else {
      return [];
    }
  }
}
